// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__zkknp","tabHeader":"styles_tabHeader__4Gw-X","titlesContainer":"styles_titlesContainer__Z1EMk"};